<template>
    <div>
    <b-modal
      hide-footer
      size="xl"
      centered
      ref="add-user-modal"
      id="add-user-modal"
      title="Adicionar novo usuário">
    </b-modal>
    </div>
</template>

<script>
import templatePrice from './templatePrice'
export default templatePrice
</script>

<style scoped>

.container-user-form{
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10,1fr);
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/templatePrice/templatePrice.vue